import { ReactNode, useState } from "react";
import { Location, useLocation } from "react-router";
import { LocationHistoryContext } from "./useLocationHistory.shared";

export const LocationHistoryProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const location = useLocation();

  // most recent location is the first in the array
  const [locationHistory, setLocationHistory] = useState<Location[]>([]);
  const [trackedLocation, setTrackedLocation] = useState(location);

  // When location changes, push the previous location onto history (render-time).
  if (location !== trackedLocation) {
    setLocationHistory((currentLocationHistory) =>
      [trackedLocation, ...currentLocationHistory].slice(0, 49),
    );
    setTrackedLocation(location);
  }

  return (
    <LocationHistoryContext.Provider value={locationHistory}>
      {children}
    </LocationHistoryContext.Provider>
  );
};
